
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * N-291: «Confirmar» se bloquea («cargando») desde el primer clic hasta que quien la abrió la
 * cierra (`close()`, al acabar bien) o la libera (`release()`, si falla y se puede reintentar).
 * Antes un doble clic en «Reenviar» mandaba dos correos al profesor.
 */
@Component({})
export default class ActionConfirmation extends Vue {
  @Prop({ default: "Confirm Action", required: false }) private title;
  @Prop({ default: "", required: true }) private text;

  private dialog = false;
  private working = false;

  show() {
    this.working = false;
    this.dialog = true;
  }

  confirm() {
    if (this.working) {
      return;
    }
    this.working = true;
    this.$emit('confirmed');
  }

  release() {
    this.working = false;
  }

  close() {
    this.working = false;
    this.dialog = false;
  }
}
